import styled from "styled-components";
import Leftside from "./Leftside";
import Main from "./Main";
import Rightside from "./Rightside";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";


const Home = (props) => {
    return(
        <Container>
            {!props.user && <Navigate to = "/" ></Navigate>}
            <Section>
                <h4> 
                    <a>Job Chahiye? Mil Jayegi -  </a>
                </h4>
                <p>
                &nbsp; Discover free and easy ways to find a great hire, fast. 
                </p>
            </Section>
            <Layout>
                <Leftside></Leftside>
                <Main></Main>
                <Rightside></Rightside>
            </Layout>
        </Container>

    );
    
};

const Container = styled.div`
    padding-top: 52px;  
    max-width: 100%;
`;
const Content = styled.div`
    max-width: 1128px;
    margin-left: auto;
    margin-right: auto;

`;
const Section = styled.section`
    min-height: 50px;
    padding: 16px 0;
    box-sizing: content-box;
    text-align: center;
    text-decoration: underline;
    display: flex;                 /*this and justify content made everything come in one line */
    justify-content: center;
    h4 {
        color: #0a66c2;
        // font-size: 14px;

        a {
            font-weight: 700;
        }
    }

    p {
        font-size: 16px;
        color: #434649;
        font-weight: 600;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 0 5px;
        /*you can give different styling to all the tags and 
        everything else by giving them styling inside media for 
        changing it in mobile */
    }
`;
const Layout = styled.div`
    display: grid;
    grid-template-areas: "leftside main rightside";
    grid-template-columns: minmax(0, 5fr) minmax(0, 12fr) minmax(300px, 7fr);
    column-gap: 25px;
    row-gap: 25px;
    grid-template-rows: auto;
    margin: 25px 0;
    @media (max-width: 768px){
        display: flex;
        flex-direction: column; /*mobile ma they will appear in row format. each column as a row */
        padding: 0 5px;
    }
`;

const mapStateToProps = (state) => {
    return {
        user: state.userState.user,
    };
};

export default connect(mapStateToProps)(Home);
